export default __webpack_public_path__ + "media/images/corporate/apartments/second_slide_lg-5d01a9ba3ec9e453be8d9380f6eab25a.png";